module.exports = __webpack_public_path__ + "img/stars.77d36c82.jpg";